import * as React from "react";
import { Grid } from '@material-ui/core';
import clsx from 'clsx';
import LogoHeader from '../layout/header/LogoHeader'
import HorizontalLogoHeader from "../layout/header/HorizontalLogoHeader";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({    
    logoContainer: {
      marginLeft: '27%'
    },
}));

export default function LoginHeader () {
    
  const classes  = useStyles();

  return(
    <Grid container className={clsx(classes.loginHeader, 'loginHeader')}>
      <Grid container xs={9}>
        <div className={clsx(classes.logoContainer, 'logoContainer')}>
          <LogoHeader/>
        </div>
      </Grid>
      <Grid container xs={3}>
          <HorizontalLogoHeader/>
      </Grid>
    </Grid>
  );
}